// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { placeholder, forIn, concat, compact, mergeWith } from 'lodash/fp';

const setParent = object => {
  forIn(child => {
    child.parent = object;
    setParent(child);
  }, object.children);
};

const routeConfig = {
  Settings: {
    name: 'Settings',
    optionalParam: ['(/:notSetupDatabase)']
  },
  Explore: {
    name: 'Explore',
    // path: '/'
    //optionalParam: ['(/:notSetupDatabase)']
  },
  Report: {
    name: 'Report',
    children: {
      List: {
        name: 'ReportList',
        path: 'list/:reportType(/:catId(/:isGlobal))'
      },
      View: {
        name: 'View',
        path: 'view/:id(/:version)'
      },
      Edit: {
        name: 'ReportsEdit',
        path: 'edit/:id(/:version)'
      },
      IframeExport: {
        name: 'Iframe',
        path: 'iframe/:id(/:version)'
      }
    }
  },
  Dashboard: {
    name: 'Dashboard',
    children: {
      List: {
        name: 'DashboardList',
        path: 'list/:catId(/:dashboardId(/:isGlobal))'
      },
      New: {
        name: 'NewDashboard',
        path: 'new'
      },
      Edit: {
        name: 'EditDashboard',
        path: 'edit/:id'
      },
      DashboardViewer: {
        name: 'DashboardViewer',
        path: ':id'
      }
    }
  },
  ReportDesigner: {
    name: 'ReportDesigner',
    children: {
      ReportDesignerDetail: {
        name: 'ReportDesignerDetail',
        path: ':reportId'
      }
    }
  },
  ReportViewer: {
    name: 'ReportViewer',
    children: {
      ReportViewerDetail: {
        name: 'ReportViewerDetail',
        path: ':id'
      }
    }
  },
  Viewer: {
    name: 'Viewer',
    children: {
      ReportPart: {
        name: 'ReportPart',
        path: 'reportpart/:id'
      },
      DashboardPart: {
        name: 'DashboardPart',
        path: 'dashboardpart/:id'
      },
      ReportBody: {
        name: 'ReportBody',
        path: 'reportbody/:id'
      },
      Dashboard: {
        name: 'Dashboard',
        path: 'dashboard/:id'
      }
    }
  },
  Account: {
    name: 'account',
    children: {
      Activation: {
        name: 'Activation',
        path: 'activation'
      },
      Login: {
        name: 'Login',
        path: 'login'
      },
      ResetPassword: {
        name: 'ResetPassword',
        path: 'resetPassword'
      },
      ForgotPassword: {
        name: 'ForgotPassword',
        path: 'forgotPassword'
      }
    }
  },
  MyProfile: {
    name: 'MyProfile',
    children: {
      PersonalInfo: {
        name: 'PersonalInfo',
        path: 'personalinfo'
      },
      SecurityOptions: {
        name: 'SecurityOptions',
        path: 'securityoptions'
      }
    }
  }
};

forIn(setParent, routeConfig);

// This contents the uri for going back later using router.
const SOURCE_PATH_QUERY_KEY = 'spath';

export default {
  routeConfig,
  mergeRouteConfig: mergeWith(
    (objValue, srcValue) => {
      srcValue.path = compact(concat(objValue, srcValue.optionalParam)).join('');
      return srcValue;
    },
    placeholder,
    routeConfig
  ),
  SOURCE_PATH_QUERY_KEY
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.RouteConstants.js